module.exports = __webpack_public_path__ + "static/img/2_3_3.e1163f6c.jpg";